import { api } from "./axios";

export const getProperties = () => api.get("/api/properties").then((r) => r.data);
export const createProperty = (payload) => api.post("/api/properties", payload).then((r) => r.data);
export const updateProperty = (id, payload) => api.put(`/api/properties/${id}`, payload).then((r) => r.data);
export const deleteProperty = (id) => api.delete(`/api/properties/${id}`).then((r) => r.data);
